import React from 'react';

const SIZES = {
  sm: 'h-10 w-10',
  md: 'h-12 w-12',
  lg: 'h-14 w-14',
};

export function BrandLogo({ size = 'sm', className = '' }) {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/mungkorn-logo.png`}
      alt="Mungkorn Lotto"
      className={`shrink-0 rounded-full object-cover ${SIZES[size] || SIZES.sm} ${className}`}
    />
  );
}
